'use strict'

/**
 * Objeto con las validaciones para formulario de Pago X Identificacion.
 *
 * @author Valentin Agudelo Aquite
 * @since 03/03/2020 04:10 PM
 * @version 1.0.0
 */
export default {
  obraId: {
    required: true
  },
  campanaDonacionId: {
    required: true
  },
  tipoDocumentoId: {
    required: true
  },
  numeroDocumento: {
    required: true,
    max: 20,
    alpha_num: true
  },
  nombre: {
    required: true,
    max: 80,
    alpha_spaces: true
  },
  observaciones: {
    required: true,
    max: 4000
  },
  correo: {
    required: true,
    max: 60,
    email: true
  },
  telefono: {
    max: 15,
    numeric: true
  },
  valor: {
    required: true,
    max: 20
  },
  aceptaTerminosCondiciones: {
    required: true
  },
  aceptaTratamientoDatos: {
    required: false
  },
  tipoMoneda: {
    required: true
  }
}
